export enum CLASS_NUMBER_SELECTOR_VIEW {
    DEFAULT = 'default',
    PLAIN = 'plain',
}

export enum CLASS_NUMBER_SELECTOR_MODE {
    EDIT = 'edit',
    CREATE = 'create',
}
